(() => {
  if (customElements.get('theme-product-badges')) return;

  // Detail rows equalize intrinsic label widths. Card rows only display when
  // every whole word fits and the overlay stays compact inside the photograph.
  class ThemeProductBadges extends HTMLElement {
    connectedCallback() {
      this.scheduleLayout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.layoutBadges());
      };
      this.resizeObserver = new ResizeObserver(this.scheduleLayout);
      this.resizeObserver.observe(this.parentElement);
      this.mutationObserver = new MutationObserver(this.scheduleLayout);
      this.mutationObserver.observe(this, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
      document.fonts.addEventListener('loadingdone', this.scheduleLayout);
      document.fonts.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
      this.scheduleLayout();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.layoutFrame);
      this.resizeObserver.disconnect();
      this.mutationObserver.disconnect();
      document.fonts.removeEventListener('loadingdone', this.scheduleLayout);
    }

    layoutCardBadges(badges) {
      const media = this.parentElement.getBoundingClientRect();
      const group = this.getBoundingClientRect();
      let fits = badges.length > 0 && media.width >= 160 && group.height <= media.height * 0.35;
      for (const badge of badges) {
        const bounds = badge.getBoundingClientRect();
        const style = getComputedStyle(badge);
        const chrome = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const maxHeight = 3 * parseFloat(style.lineHeight) + chrome;
        fits = fits && bounds.height <= maxHeight + 1 &&
          badge.scrollWidth <= badge.clientWidth + 1 &&
          bounds.left >= group.left - 1 && bounds.right <= group.right + 1 &&
          bounds.top >= media.top - 1 && bounds.bottom <= media.bottom + 1;
      }
      this.dataset.themeBadgesFit = String(fits);
    }

    layoutBadges() {
      const badges = [...this.children].filter((badge) => !badge.hidden);
      if (this.classList.contains('theme-product-badges--card')) {
        this.layoutCardBadges(badges);
        return;
      }
      this.style.removeProperty('--theme-product-badge-width');
      if (badges.length < 2) return;
      const container = this.parentElement;
      const style = getComputedStyle(container);
      const availableWidth = container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      // max-content measurement is temporary and local; long labels retain all text.
      const widths = badges.map((badge) => {
        badge.style.inlineSize = 'max-content';
        badge.style.maxInlineSize = 'none';
        const width = badge.getBoundingClientRect().width;
        badge.style.removeProperty('inline-size');
        badge.style.removeProperty('max-inline-size');
        return width;
      });
      this.style.setProperty('--theme-product-badge-width', `${Math.min(Math.max(...widths), availableWidth)}px`);
    }
  }

  customElements.define('theme-product-badges', ThemeProductBadges);
})();
